import { Link } from 'react-router-dom'

function DryFieldIllustration() {
  return (
    <svg
      viewBox="0 0 200 120"
      className="w-48 h-auto mx-auto text-amber-700/60"
      aria-hidden="true"
    >
      <rect x="0" y="90" width="200" height="30" fill="currentColor" opacity="0.25" />
      <path
        d="M20 90 Q30 70 40 90 M50 90 Q58 65 66 90 M75 90 Q85 72 95 90"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        opacity="0.4"
      />
      <path d="M100 90 L100 45" stroke="#854d0e" strokeWidth="3" strokeLinecap="round" />
      <path
        d="M100 55 Q85 40 78 52 Q92 48 100 55 Q108 48 122 52 Q115 40 100 55"
        fill="#ca8a04"
        opacity="0.7"
      />
      <path
        d="M100 68 Q88 58 82 68 Q95 62 100 68 Q105 62 118 68 Q112 58 100 68"
        fill="#a16207"
        opacity="0.5"
      />
      <circle cx="160" cy="30" r="18" fill="#fde047" opacity="0.8" />
    </svg>
  )
}

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <div className="w-full max-w-md text-center space-y-6">
        <DryFieldIllustration />
        <h2 className="text-2xl font-bold text-gray-900">Página não encontrada</h2>
        <p className="text-sm text-gray-500">
          O endereço que você acessou não existe ou foi movido.
        </p>
        <Link
          to="/dashboard"
          className="inline-block px-6 py-3 bg-hydro-600 text-white rounded-lg font-medium hover:bg-hydro-700 transition-colors duration-200"
        >
          Ir para o dashboard
        </Link>
      </div>
    </div>
  )
}
